import * as Sentry from '@sentry/gatsby'

import { beforeSend, ignoreErrors } from './src/utils/sentry'

// This global name is fixed by @sentry/gatsby's Webpack DefinePlugin.
// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle
declare const __SENTRY_RELEASE__: string | undefined

const environment = process.env.GATSBY_ENV || 'development'

Sentry.init({
  dsn: 'https://cb5d728ad4a44734bced51daa20f0ca8@o925641.ingest.sentry.io/5890043',
  environment,
  release: __SENTRY_RELEASE__,
  // Only send events in production so local and staging traffic do not create noise.
  sampleRate: environment === 'production' ? 1 : 0,
  beforeSend,
  ignoreErrors,
})
